

import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueResource from 'vue-resource'
import Mint from 'mint-ui'
import App from './App'
import index from './views/index'
import detail from './views/saas/detail'
import patchdetail from './views/mall/paas/patchdetail'
import sassList from './views/saas/saasList'
import sassIndex from './views/saas/saasIndex'
import passIndex from './views/paas/paasIndex'
import passSearch from './views/paas/paasSearch'

import hwIndex from './views/hw/hwIndex'
import hwDetail from './views/hw/hwDetail'
import hwSearch from './views/hw/hwSearch'
import docIndex from './views/doc/docIndex'
import docSearch from './views/doc/docSearch'
import docDetail from './views/doc/docDetail'
import resourceDownload from './views/doc/resourceDownload'
import resourceDetail from './views/doc/resourceDetail'
import demandIndex from './views/demand/demandIndex'
import developerList from './views/developer/developerList'
import developerDetail from './views/developer/developerDetail'
import learnIndex from './views/learn/learnIndex'
import cooperation from './views/learn/cooperation'
import develop from './views/learn/develop'
import childcloud from './views/learn/childcloud'
import tryout from './views/learn/tryout'
import buySelect from './views/learn/buySelect'
import buyTryOut from './views/learn/buyTryOut'
import productIndex from './views/learn/productIndex'
import productList from './views/learn/productList'
import productDetail from './views/learn/productDetail'
import register from './views/auth/register'
import law from './views/auth/law'
import registerSuccess from './views/auth/registerSuccess'
import login from './views/auth/login'
import fotgetPassword from './views/auth/fotgetPassword'
import fotgetPassword2 from './views/auth/fotgetPassword2'
import cert1 from './views/user/cert1'
import cert2 from './views/user/cert2'
import cert3 from './views/user/cert3'
import userIndex from './views/user/userIndex'
import editInfo from './views/user/editInfo'
import editName from './views/user/editName'
import changePassword from './views/user/changePassword'
import changePasswordSucceed from './views/user/changePasswordSucceed'
import loginOut from './views/user/loginOut'
import collection from './views/user/collection'
import collectionManage from './views/user/collectionManage'
import userMessage from './views/user/userMessage'
import userMessageManage from './views/user/userMessageManage'
import foot from './views/user/foot'
import scoreList from './views/score/list'
import scoreDetail from './views/score/detail'
import global from './views/common.vue'
import saasSearch from './views/saas/saasSearch'
import 'mint-ui/lib/style.css'
import { Loadmore } from 'mint-ui';
Vue.component(Loadmore.name, Loadmore);
import { Spinner } from 'mint-ui';
Vue.component(Spinner.name, Spinner);
import newindex from './views/newindex/newindex.vue'
import mallindex from './views/mall/mallIndex.vue'
import appList from './views/mall/app/list.vue'
import developerIndex from './views/newdeveloper/developerIndex.vue'
import cooperationIndex from './views/cooperation/cooperationIndex.vue'
import serviceIndex from './views/service/serviceIndex.vue'
import codeList from './views/mall/paas/list.vue'
import hardwareList from './views/mall/hardware/list.vue'
import hardwareDetail from './views/mall/hardware/detail.vue'
import paasDetail from './views/mall/paas/detail.vue'
import demandDetail from './views/mall/demand/detail.vue'
import demandList from './views/mall/demand/list.vue'
import appDetail from './views/mall/app/detail.vue'
import appDetail1 from './views/mall/app/detail1.vue'
import newbieGuide from './views/developer/developerIndex'
import SnsNewsDetail from './views/sns/news/detail.vue'
import SnsQuestiontDetail from './views/sns/question/detail.vue'
import SnsBbsDetail from './views/sns/bbs/detail.vue'
import GoodsSearch from './views/goods/search.vue'

import NtalkAppDetail from './views/ntalk/mall/app/detail.vue'
import NtalkAppDetail1 from './views/ntalk/mall/app/detail1.vue'
import NtalkAppList from './views/ntalk/mall/app/list.vue'
import NtalkPaasDetail from './views/ntalk/mall/paas/detail.vue'
import NtalkPaasList from './views/ntalk/mall/paas/list.vue'
import NtalkHardwareDetail from './views/ntalk/mall/hardware/detail.vue'
import NtalkHardwareList from './views/ntalk/mall/hardware/list.vue'
import loginHeader from './views/ntalk/loginHeader.vue'
import NtalkGoodsSearch from './views/ntalk/goods/search.vue'
import NtalkDemandDetail from './views/ntalk/mall/demand/detail.vue'

import subordinateCompany from './views/user/subordinateCompany'

import SnsActivitydetail from './views/sns/activity/detail.vue'
import Consultlist from './views/consult/consultlist'
import Consultdetail from './views/consult/consultdetail'

import Sharelist from './views/consult/sharelist.vue'
import Sharedetail from './views/consult/sharedetail.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import JSEncrypt from 'jsencrypt';


Vue.prototype.$getRsaCode = function(str){ // 注册方法

let pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDJZCm3JXtAYGK7Q/5V15ZSc7k2y73yqHhgQwkGrVe9GKbX54/S4Rg147dDXzQAQpvWrYcft+Lb1dK6RUmSau7qmzwEOcm+G4qh34VGwzZNgE43ZLtQXQrY0KGlKuZ0wotvU8iTaqHpHQO5P4k2YKT8JpIjCAzUODoRKGnc1HbaGwIDAQAB`;
let encryptStr = new JSEncrypt();
encryptStr.setPublicKey(pubKey); 
let data = encryptStr.encrypt(str.toString());  
let ps= encodeURI(data).replace(/\+/g, '%2B');
return ps;
}

Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(Vant)

Vue.use(Mint)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.prototype.$axios = axios
Vue.prototype.global = global

const routes = [
{
path: '/',

component: newindex
},
{
path: '/newindex',
component: newindex
},

{
path: '/mall/index',
component: mallindex
},
{
path: '/mall/app/List',
component:appList
},
{
path: '/mall/paas/list',
component:codeList
},
{
path: '/mall/hardware/list',
component:hardwareList
},
{
path: '/mall/demand/list',
component:demandList
},
{
path: '/app/cooperation/index',
component: cooperationIndex
},
{
path: '/app/service/index',
component: serviceIndex
},
{
path: '/mall/paas/patchdetail',
component: patchdetail
},
{
path: '/app/saas/list',
component: sassList
},

{
path: '/app/saas/detail',
component: detail
},




{
path: '/mall/paas/list',
component: passIndex
},
{
path: '/app/paas/search',
component: passSearch
},
{
path: '/app/paas/detail',
component: paasDetail
},
{
path: '/mall/hardware/list',
component: hwIndex
},
{
path: '/mall/hardware/detail',
component: hardwareDetail
},
{
path: '/shop/hw/detail',
component: hwDetail
},
{
path: '/shop/hw/search',
component: hwSearch
},
{
path: '/doc/index',
component: docIndex
},
{
path: '/doc/search',
component: docSearch
},
{
path: '/doc/detail',
component: docDetail
},
{
path: '/doc/resourceDownload',
component: resourceDownload
},
{
path: '/doc/resourceDetail',
component: resourceDetail
},
{
path: '/mall/demand/list',
component: demandIndex
},
{
path: '/developer/index',
component: developerIndex
},
{
path: '/developer/list',
component: developerList
},
{
path: '/developer/detail',
component: developerDetail
},
{
path: '/learn/index',
component: learnIndex
},
{
path: '/learn/cooperation',
component: cooperation
},
{
path: '/learn/cooperation/develop',
component: develop
},
{
path: '/learn/cooperation/childcloud',
component: childcloud
},
{
path: '/learn/tryout',
component: tryout
},
{
path: '/learn/buySelect',
component: buySelect
},
{
path: '/learn/buyTryOut',
component: buyTryOut
},
{
path: '/learn/product/index',
component: productIndex
},
{
path: '/learn/product/list',
component: productList
},
{
path: '/learn/product/detail',
component: productDetail
},
{
path: '/auth/register',
component: register
},
{
path: '/auth/law',
component: law
},
{
path: '/auth/registerSuccess',
component: registerSuccess
},
{
path: '/auth/login',
component: login
},
{
path: '/auth/fotgetPassword',
component: fotgetPassword
},
{
path: '/auth/fotgetPassword2',
component: fotgetPassword2
},
{
path: '/user/cert/cert1',
component: cert1
},
{
path: '/user/cert/cert2',
component: cert2
},
{
path: '/user/cert/cert3',
component: cert3
},
{
path: '/user/index',
component: userIndex
},
{
path: '/user/editInfo',
component: editInfo
},
{
path: '/user/editName',
component: editName
},
{
path: '/user/changePassword',
component: changePassword
},
{
path: '/user/changePasswordSucceed',
component: changePasswordSucceed
},
{
path: '/user/loginOut',
component: loginOut
},
{
path: '/user/collection',
component: collection
},
{
path: '/user/collectionManage',
component: collectionManage
},
{
path: '/user/userMessage',
component: userMessage
},
{
path: '/user/userMessageManage',
component: userMessageManage
},
{
path: '/user/foot',
component: foot
},
{
path: '/score/list',
component: scoreList
},
{
path: '/score/detail',
component: scoreDetail
},
{
path:'/saas/search',
component: saasSearch
},
{
path: '/mall/paas/detail',
component: paasDetail
},
{
path: '/mall/demand/detail',
component: demandDetail

},
{
path: '/mall/app/detail',
component: appDetail
},
{
path: '/mall/app/detail1',
component: appDetail1
},
{
path: '/developer/newbieGuide',
component: newbieGuide
}




,
{
path: '/sns/news/detail',
component: SnsNewsDetail
},
{
path: '/sns/question/detail',
component: SnsQuestiontDetail
},
{
path: '/sns/bbs/detail',
component: SnsBbsDetail
},
{
path: '/goods/search',
component: GoodsSearch

},
{
path: '/ntalk/mall/app/detail',
component: NtalkAppDetail
},
{
path: '/ntalk/mall/app/detail1',
component: NtalkAppDetail1
},
{
path: '/ntalk/mall/app/list',
component: NtalkAppList
},
{
path: '/ntalk/mall/paas/detail',
component: NtalkPaasDetail
},
{
path: '/ntalk/mall/paas/list',
component: NtalkPaasList
},
{
path: '/ntalk/mall/hardware/list',
component: NtalkHardwareList
},
{
path: '/ntalk/mall/hardware/detail',
component: NtalkHardwareDetail
},
{
path: '/ntalk/goods/search',
component: NtalkGoodsSearch

},
{
path: '/ntalk/mall/demand/detail',
component: NtalkDemandDetail
},
{
path:'/sns/activity/detail',
component:SnsActivitydetail
},{
path:'/consult/consultlist',
component:Consultlist
},{
path:'/consult/consultdetail',
component:Consultdetail
},

{
path:'/consult/sharelist',
component:Sharelist
},

{
path:'/consult/sharedetail',
component:Sharedetail
},

{
path:'/user/subordinateCompany',
component:subordinateCompany
}
]

const router = new VueRouter({
routes,
mode:'history'
})


router.afterEach(function (to) {
if(document.getElementById("app")!=null){
document.getElementById("app").scrollTo(0, 0)
}


});

router.afterEach( ( to, from, next ) => {
setTimeout(()=>{
var _hmt = _hmt || [];
(function() {

document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
var hm = document.createElement("script");
hm.src = "https://hm.baidu.com/hm.js?22c1001a656acb63c91abffeeb5e9419";
hm.id = "baidu_tj"
var s = document.getElementsByTagName("script")[0];
s.parentNode.insertBefore(hm, s);
})();
},0);
} );

FastClick.attach(document.body)

Vue.config.productionTip = false


Vue.prototype.setUser = function(token,mobile){
this.$cookies.set("mtoken",token,3600);
this.$cookies.set("mobile",mobile,3600);
}

Vue.prototype.getToken = function(){
return this.$cookies.get("mtoken");
}

Vue.prototype.getUserMobile = function(){
return this.$cookies.get("mobile");
}

Vue.prototype.isLogin = function(){
var token = this.getToken();
if(token == null || token == ""){
return false;
}else{
return true;
}
}

Vue.prototype.upUser = function(){
this.$cookies.set("mtoken",this.getToken(),3600);
this.$cookies.set("mobile",this.getUserMobile(),3600);
}

Vue.prototype.removeUser = function(){
this.$cookies.remove("mtoken");
this.$cookies.remove("mobile");
}

Vue.http.interceptors.push((request, next) => {
var token = $cookies.get("mtoken");
if(token!=null && token!=""){
request.params = {"m_token":token};
$cookies.set("mtoken",token,3600);
$cookies.set("mobile",$cookies.get("mobile"),3600);
}

});


/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js